import { splunkInstance } from '@/common/services/splunk';

export type DoctorDesktopChatsEntry = 'header' | 'sidebar' | 'avatar_menu';

/** کلیک میانبر دسکتاپ «گفت‌وگوها» — برای شمارش استفاده از فردا. */
export const sendDoctorDesktopChatsClick = (
  userId: string | number | undefined,
  entry: DoctorDesktopChatsEntry,
) => {
  if (userId == null || userId === '') return;

  splunkInstance('dashboard').sendEvent({
    group: 'launcher_statistics',
    type: 'widget_features',
    event: {
      feature: 'desktop_chats_click',
      user_id: userId,
      is_doctor: true,
      meta_data: { entry },
    },
  });
};
